module.exports = __webpack_public_path__ + "img/yinsi.23ba9b02.svg";